import { useContext } from 'react'

import { ReservationContext } from '@/context'

export const useReservation = () => useContext(ReservationContext)
